import { Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/layout/Layout.jsx';
import Home from './pages/home.jsx';
import Contact from './pages/contact.jsx';
import LegaleNotice from './pages/legale-notice.jsx';
import SiteMap from './pages/site-map.jsx';
import Services from './pages/services.jsx';
import Achievements from './pages/achievements.jsx';

function App() {
  return (
      <div className="App">
        <Layout>
          <Routes>
            {/* Menu Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/achievements" element={<div style={{ padding: '100px 20px', textAlign: 'center' }}><h1>Réalisations</h1><p>Page en cours de construction...</p></div>} />

            {/* Legal Pages */}
            <Route path="/legale-notice" element={<LegaleNotice />} />
            <Route path="/site-map" element={<SiteMap />} />

            {/* Error Page */}
            <Route path="*" element={<div style={{ padding: '100px 20px', textAlign: 'center' }}><h1>404 - Page non trouvée</h1></div>} />
          </Routes>
        </Layout>
      </div>
  );
}

export default App;
